import * as React from "react";
export class BetBtn extends React.PureComponent {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
        this.timeout = 0;
        this.oddsDefaultClass = "rj-ev-list__bet-btn--odd-init";
        this.oddsUpClass = "rj-ev-list__bet-btn--odd-up";
        this.oddsDownClass = "rj-ev-list__bet-btn--odd-down";
        this.chosenClass = "rj-ev-list__bet-btn--chosen";
        this.removeOddsClassDuration = 1600;
        this.btnClass = this.oddsDefaultClass;
    }
    noop() { return false; }
    fnRouter(handler) {
        return (typeof handler !== "function" ? this.noop : handler)();
    }
    setOddsClass(prevProps, props) {
        if (this.buttonRef && this.buttonRef.current) {
            this.buttonRef.current.classList.remove(this.btnClass);
            this.btnClass = this.getOddsClass(prevProps, props);
            this.buttonRef.current.classList.add(this.btnClass);
        }
    }
    getOddsClass(prevProps, props) {
        return props.trueOdds > prevProps.trueOdds ? this.oddsUpClass : this.oddsDownClass;
    }
    removeOddsClass() {
        if (this.buttonRef && this.buttonRef.current) {
            this.buttonRef.current.classList.remove(this.btnClass);
            this.btnClass = this.oddsDefaultClass;
            this.buttonRef.current.classList.add(this.btnClass);
        }
    }
    updateOddsClass(prevProps, props) {
        if (typeof props.trueOdds === "undefined") {
            return false;
        }
        else {
            if (prevProps.trueOdds !== props.trueOdds) {
                clearTimeout(this.timeout);
                this.setOddsClass(prevProps, props);
                this.timeout = setTimeout(this.removeOddsClass.bind(this), this.removeOddsClassDuration);
                return true;
            }
            return false;
        }
    }
    shouldRenderText() {
        return this.props.text ? true : false;
    }
    shouldRenderPoints() {
        return typeof this.props.point === "string"
            && this.props.point.length !== 0;
    }
    shouldRenderOdds() {
        return this.props.trueOdds !== 0
            && !this.shouldBeDisabled();
    }
    renderText() {
        return this.shouldRenderText()
            && React.createElement("span", { className: "rj-ev-list__bet-btn__content rj-ev-list__bet-btn__text", "data-uat": "ev-list-ev-list-bet-btn-text" }, this.props.text);
    }
    renderPoints() {
        return this.shouldRenderPoints()
            && React.createElement("span", { className: "rj-ev-list__bet-btn__content rj-ev-list__bet-btn__point", "data-uat": "ev-list-ev-list-bet-btn-point" }, this.props.point);
    }
    renderOdds() {
        return this.shouldRenderOdds()
            && React.createElement("span", { className: "rj-ev-list__bet-btn__content rj-ev-list__bet-btn__odd", "data-uat": "ev-list-ev-list-bet-btn-odd" }, this.props.odd);
    }
    renderContent() {
        return (React.createElement("div", { className: `rj-ev-list__bet-btn__inner`, "data-uat": "ev-list-ev-list-bet-btn-inner" },
            this.renderText(),
            this.renderPoints(),
            this.renderOdds()));
    }
    renderArrows() {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "rj-ev-list__bet-btn__arrow-up" }),
            React.createElement("span", { className: "rj-ev-list__bet-btn__arrow-down" })));
    }
    componentDidUpdate(prevProps) {
        this.updateOddsClass(prevProps, this.props);
    }
    shouldBeDisabled() {
        return (this.props.hideLowOdds && this.containsZeroOdds()) ? true : false;
    }
    containsZeroOdds() {
        return this.props.trueOdds
            && this.props.trueOdds >= 0.001
            && this.props.trueOdds < 1.01;
    }
    render() {
        const btnClass = `rj-ev-list__bet-btn ${this.props.classNames ? this.props.classNames : ""}`;
        return (React.createElement("button", { ref: this.buttonRef, className: btnClass, onClick: this.fnRouter.bind(this, this.props.handler), disabled: this.props.isDisabled || this.shouldBeDisabled(), "data-uat": `button-ev-list-bet-btn` },
            this.renderContent(),
            this.renderArrows()));
    }
}
//# sourceMappingURL=BetBtn.js.map